/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './recipe.reducer';

export const RecipeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const recipeEntity = useAppSelector(state => state.recipe.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="recipeDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.recipe.detail.title">Recipe</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.recipe.id">Id</Translate>
            </span>
          </dt>
          <dd>{recipeEntity.id}</dd>
          <dt>
            <span id="uri">
              <Translate contentKey="tinyMedicRestApp.recipe.uri">Uri</Translate>
            </span>
          </dt>
          <dd>{recipeEntity.uri}</dd>
          <dt>
            <span id="tmLabel">
              <Translate contentKey="tinyMedicRestApp.recipe.tmLabel">Tm Label</Translate>
            </span>
          </dt>
          <dd>{recipeEntity.tmLabel}</dd>
          <dt>
            <span id="image">
              <Translate contentKey="tinyMedicRestApp.recipe.image">Image</Translate>
            </span>
          </dt>
          <dd>{recipeEntity.image}</dd>
          <dt>
            <span id="source">
              <Translate contentKey="tinyMedicRestApp.recipe.source">Source</Translate>
            </span>
          </dt>
          <dd>{recipeEntity.source}</dd>
          <dt>
            <span id="url">
              <Translate contentKey="tinyMedicRestApp.recipe.url">Url</Translate>
            </span>
          </dt>
          <dd>{recipeEntity.url}</dd>
          <dt>
            <span id="reference">
              <Translate contentKey="tinyMedicRestApp.recipe.reference">Reference</Translate>
            </span>
          </dt>
          <dd>{recipeEntity.reference}</dd>
          <dt>
            <span id="yeild">
              <Translate contentKey="tinyMedicRestApp.recipe.yeild">Yeild</Translate>
            </span>
          </dt>
          <dd>{recipeEntity.yeild}</dd>
          <dt>
            <span id="calories">
              <Translate contentKey="tinyMedicRestApp.recipe.calories">Calories</Translate>
            </span>
          </dt>
          <dd>{recipeEntity.calories}</dd>
          <dt>
            <span id="totalweight">
              <Translate contentKey="tinyMedicRestApp.recipe.totalweight">Totalweight</Translate>
            </span>
          </dt>
          <dd>{recipeEntity.totalweight}</dd>
          <dt>
            <span id="totaltime">
              <Translate contentKey="tinyMedicRestApp.recipe.totaltime">Totaltime</Translate>
            </span>
          </dt>
          <dd>{recipeEntity.totaltime}</dd>
        </dl>
        <Button tag={Link} to="/recipe" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/recipe/${recipeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default RecipeDetail;
